import React from "react";
import { Link } from "react-router-dom";
import { Container, ListGroup } from "react-bootstrap";
import FormsButton from "../../components/FormSection/FormsButton";
import classes from "../../components/FormSection/FormsButton.module.css";

const linkItems = [
    {
      name: "Loan Servicing Order Form",
      href: "/lender/loan-servicing-order-form",
    },
    { name: "Demand Request Form", href: "/lender/demand-request-form" },
  //   {
  //     name: "Verification of Mortgage",
  //     href: "/lender/verification-of-mortgage",
  //   }, // Update the hrefs accordingly
  //   { name: "1003 Loan Application", href: "/lender/1003-loan-application" },
  //   {
  //     name: "Statement of Information",
  //     href: "/lender/statement-of-information",
  //   },
  //   { name: "Signature Authorization", href: "/lender/signature-authorization" },
  { name: "IRS - W9 Form", href: "/lender/IRS-W9-form" },
  { name: "Add'l Lender Form", href: "/lender/additional-lender-form" },
  {
    name: "Verification of Mortgage",
    href: "/lender/verification-of-mortgage",
  },
  {
    name: "ACH Enrollment Form",
    href: "/lender/ach-enrollment-form",
  },

  {
    name: "Lender 3rd Party Auth.",
    href: "/lender/3rd-party-auth",
  },
  {
    name: "Change of Address Form",
    href: "/lender/change-of-address",
  },
  {
    name: "Loan Document Order Form",
    href: "/lender/loan-document-order-form",
  },
  { name: "Draw Request Form", href: "/lender/draw-request-form" },
];

const LenderForms = () => {
  return (
     <section
     className="text-start container-fluid my-4 px-0 rounded"
     style={{ background: "#eeeeee", minHeight: "100vh" }}
   >
     <div className="container-fluid">
       <div className="p-3 pb-0  mt-1">
         <div style={{ backgroundColor: "#FF8057", padding: "36px 0" }}>
           <h3
             style={{
               fontSize: "55px",
               color: "#fff",
               textAlign: "center",
               padding: "17px 0",
             }}
           >
             Lender Forms
           </h3>
         </div>
         <FormsButton
           heading="Loan servicing forms"
           options={linkItems}
           classname={classes.background}
         />
       </div>
     </div>
   </section>
  );
};

export default LenderForms;
